import { Middleware } from '@reduxjs/toolkit';
import { authQuery } from 'service/authQuery/authQuery';
import { candidateQuery } from 'service/candidateQuery/candidateQuery';
import { institutionQuery } from 'service/institutionQuery/institutionQuery';
import { quizAssessmentQuery } from 'service/quizAssessmentQuery/quizAssessmentQuery';
import { quizzesQuery } from 'service/quizzesQuery/quizzesQuery';
import { recruiterQuery } from 'service/recruiterQuery/recruiterQuery';
import { uploadQuery } from 'service/uploadQuery/uploadQuery';
import { userQuery } from 'service/userQuery/userQuery';

const middleware: Middleware[] = [
  authQuery.middleware,
  institutionQuery.middleware,
  candidateQuery.middleware,
  quizzesQuery.middleware,
  quizAssessmentQuery.middleware,
  uploadQuery.middleware,
  recruiterQuery.middleware,
  userQuery.middleware
];

export default middleware;
